import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const sections = [
  { id: 'hero' },
  { id: 'features' },
  { id: 'methods' },
  { id: 'platform' },
  { id: 'integrations' },
  { id: 'pricing' },
  { id: 'testimonials' },
  { id: 'cta' },
];

const ScrollIndicator: React.FC = () => {
  const { t } = useTranslation();
  const [activeId, setActiveId] = useState('hero');

  useEffect(() => {
    const observers: IntersectionObserver[] = [];

    sections.forEach(({ id }) => {
      const el = document.getElementById(id);
      if (!el) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setActiveId(id);
          }
        },
        { threshold: 0.3 }
      );

      observer.observe(el);
      observers.push(observer);
    });

    return () => observers.forEach((o) => o.disconnect());
  }, []);

  const handleClick = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="hp-scroll-indicator" role="navigation" aria-label={t('scrollIndicator.ariaLabel')}>
      {sections.map(({ id }) => (
        <button
          key={id}
          className={`hp-scroll-dot${activeId === id ? ' hp-scroll-dot--active' : ''}`}
          onClick={() => handleClick(id)}
          aria-label={t('scrollIndicator.scrollTo', { id })}
        />
      ))}
    </div>
  );
};

export default ScrollIndicator;
